(function () {
  if (window.__pdFit) return; window.__pdFit = 1;
  var URLS = [
    'https://cdn.shopify.com/s/files/1/0960/7895/4798/files/pd-data-2.json',
    'https://cdn.shopify.com/s/files/1/0960/7895/4798/files/vbb-data.json',
    'https://cdn.shopify.com/s/files/1/0960/7895/4798/files/sprint-data.json',
    'https://cdn.shopify.com/s/files/1/0960/7895/4798/files/gs160-data.json',
    'https://cdn.shopify.com/s/files/1/0960/7895/4798/files/ss180-data.json',
    'https://cdn.shopify.com/s/files/1/0960/7895/4798/files/sf-data.json'
  ];
  var SKUS = (window.PD_SKUS || []).filter(Boolean);
  if (!SKUS.length) return;

  Promise.all(URLS.map(function (u) { return fetch(u).then(function (r) { return r.json(); }).catch(function () { return {}; }); })).then(function (datas) {
    var FIT = {};
    datas.forEach(function (d) { var f = (d && d.fitment) || {}; Object.keys(f).forEach(function (sku) { FIT[sku] = (FIT[sku] || []).concat(f[sku]); }); });
    var seen = {}, entries = [];
    SKUS.forEach(function (sku) {
      (FIT[sku] || []).forEach(function (row) {
        var t = row[0], h = row[1], pin = row[2];
        if (h === 'p-seat-tank') h = 'p-seattank';
        var k = h + '#' + pin;
        if (!seen[k]) { seen[k] = 1; entries.push({ t: t, h: h, pin: pin }); }
      });
    });
    if (!entries.length) return;

    var box = document.createElement('div');
    box.className = 'sm-fits sm-diag';
    box.style.cssText = 'padding:10px 20px 6px;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,system-ui,sans-serif;';
    var p = document.createElement('p');
    p.style.cssText = 'font-weight:600;color:#1a1a1a;margin:0 0 8px;';
    p.textContent = entries.length > 1 ? 'Find this part on these diagrams:' : 'Find this part on this diagram:';
    box.appendChild(p);
    var row = document.createElement('div');
    entries.forEach(function (d) {
      var a = document.createElement('a');
      a.href = '/pages/' + d.h + '?pin=' + d.pin;
      a.textContent = d.t;
      a.style.cssText = 'display:inline-flex;align-items:center;margin:0 10px 8px 0;padding:7px 13px;border:1.5px solid #1a7f37;border-radius:8px;font-weight:600;font-size:13px;color:#1a7f37;text-decoration:none;transition:background .12s,color .12s;';
      a.appendChild(document.createTextNode(' →'));
      a.addEventListener('mouseenter', function () { a.style.background = '#1a7f37'; a.style.color = '#fff'; });
      a.addEventListener('mouseleave', function () { a.style.background = 'transparent'; a.style.color = '#1a7f37'; });
      row.appendChild(a);
    });
    box.appendChild(row);

    function place() {
      var anchor = document.querySelector('.sm-fits');
      if (anchor && anchor !== box) { anchor.parentNode.insertBefore(box, anchor.nextSibling); return true; }
      var info = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper');
      if (info) { info.appendChild(box); return true; }
      return false;
    }
    if (!place()) { document.addEventListener('DOMContentLoaded', place); }
  }).catch(function (e) { if (window.console) console.error('PDfit', e); });
})();
